<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Notre Mission" />
        <MissionEitp/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import MissionEitp from './MissionEitp.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        MissionEitp,
        FooterComp,
    }
}
</script>